export function parseAssetSensorId(sensorId, index) {
    if (sensorId && sensorId.includes('.')) {
        const items = sensorId.split('.');
        if (items.length >= index) {
            return items[index];
        }
    }
    return '';
}
export function getSensorType(metaDataSensor) {
    if (metaDataSensor.assetType !== undefined) {
        const asset = metaDataSensor;
        if (asset.sensorType) {
            return asset.sensorType;
        }
        else {
            return parseAssetSensorId(asset.sensorId, 1);
        }
    }
    else if (metaDataSensor.sensorType !== undefined) {
        const sensor = metaDataSensor;
        return sensor.sensorType;
    }
    return '';
}
export function getAllSensorsType(sensors) {
    let sensorType = '';
    if (sensors && sensors.length > 0) {
        sensorType = getSensorType(sensors[0]);
        sensors.forEach((metaDataSensor) => {
            if (sensorType != 'Multiple' &&
                sensorType != getSensorType(metaDataSensor)) {
                sensorType = 'Multiple';
            }
        });
    }
    return sensorType;
}
